import { Calendar, FileText } from "lucide-react";
import { getTypeLabel } from "../../utils/helpers";

/**
 * The actual <table> for My-Escalations.
 *
 * Props:
 *   escalations    {array}
 *   loading        {boolean}
 *   theme          {string}
 *   screenSize     {string}
 *   fonts          {object}
 *   styles         {object}
 *   language       {"en"|"ar"}
 *   t              {object}
 *   StatusBadge    {component}
 *   onViewDetails  {function}  — called with escalation object
 */
const EscalationsTable = ({
  escalations,
  loading,
  theme,
  screenSize,
  fonts,
  styles,
  language,
  t,
  StatusBadge,
  onViewDetails,
}) => {
  const rowHoverOn = (e) => {
    e.currentTarget.style.background =
      theme === "dark"
        ? "rgba(255,255,255,0.05)"
        : "rgba(0,0,0,0.02)";
  };
  const rowHoverOff = (e) => {
    e.currentTarget.style.background = "transparent";
  };

  return (
    <div
      style={{
        ...styles.statCard,
        padding: 0,
        overflow: "hidden",
        marginBottom: "9rem",
      }}
    >
      <div style={{ overflowX: "auto", marginBottom: "9rem" }}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.tableHeader}>{t.escalationId}</th>
              <th style={styles.tableHeader}>{t.escalationType}</th>
              <th style={styles.tableHeader}>{t.status}</th>
              {screenSize !== "xs" && (
                <th style={styles.tableHeader}>{t.createdDate}</th>
              )}
              <th style={styles.tableHeader}>{t.actions}</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="5"
                  style={{
                    ...styles.tableCell,
                    textAlign: "center",
                    padding: "2rem",
                  }}
                >
                  {t.loading}
                </td>
              </tr>
            ) : escalations.length === 0 ? (
              <tr>
                <td
                  colSpan="5"
                  style={{ ...styles.tableCell, textAlign: "center", padding: 0 }}
                >
                  <div style={styles.emptyState}>
                    <FileText
                      size={screenSize === "xs" ? 48 : 64}
                      style={{ opacity: 0.3, marginBottom: "1rem" }}
                    />
                    <div style={{ fontSize: fonts.subtitle, fontWeight: "600" }}>
                      {t.noEscalations}
                    </div>
                    <div style={{ fontSize: fonts.body, marginTop: "0.5rem" }}>
                      {t.noEscalationsMessage}
                    </div>
                  </div>
                </td>
              </tr>
            ) : (
              escalations.map((esc) => (
                <tr
                  key={esc.id}
                  style={{ transition: "background 0.2s", cursor: "pointer" }}
                  onMouseEnter={rowHoverOn}
                  onMouseLeave={rowHoverOff}
                >
                  <td style={styles.tableCell}>
                    <strong style={{ color: "#2e7cba" }}>ESC-{esc.id}</strong>
                  </td>
                  <td style={styles.tableCell}>
                    {getTypeLabel(esc.type, language)}
                  </td>
                  <td style={styles.tableCell}>
                    <StatusBadge status={esc.status} />
                  </td>
                  {screenSize !== "xs" && (
                    <td style={styles.tableCell}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <Calendar size={14} style={{ opacity: 0.6 }} />
                        {new Date(esc.issuedAt).toLocaleDateString()}
                      </div>
                    </td>
                  )}
                  <td style={styles.tableCell}>
                    <button
                      onClick={() => onViewDetails(esc)}
                      style={{
                        ...styles.submitBtn,
                        padding: "0.25rem 0.5rem",
                        fontSize: fonts.small,
                        cursor: "pointer",
                      }}
                    >
                      {t.viewDetails}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EscalationsTable;